export const lg_mainpage = {
  lg_mainpage_th: {
      title: "มากกว่าการประชุม",
      title_page2:"ทำไมควรเลือก Dmeets?",
      title_page3:"เริ่มใช้งานฟรี ไม่มีข้อผูกมัด",
      subtitle1: "ไม่ว่าจะเป็นการประชุมธุรกิจ การให้คำปรึกษาด้านกฎหมาย หรือการสอนออนไลน์ — Dmeets คือทางเลือกที่ปลอดภัย แม่นยำ และใช้งานง่าย",
      subtitle2: "ทั้งหมดนี้รวมอยู่ในที่เดียวใน Dmeets และใช้งานได้ฟรี",
      privacy_consent:"การให้ความยินยอมเรื่องความเป็นส่วนตัว",
      text1:"DCM. จะปฏิบัติต่อข้อมูลส่วนบุคคลใด ๆ ที่ท่านได้ให้ไว้เป็นความลับและจะประมวลผลข้อมูลดังกล่าวตามเงื่อนไขและนโยบายความเป็นส่วนตัวของ DCM. เท่านั้น",
      text2:"ข้าพเจ้าได้อ่านและตกลงกับเงื่อนไขและนโยบายความเป็นส่วนตัวของ DCM.",
      accept:"ยอมรับ",
      notaccept:"ไม่ยอมรับ",
      ourpricingplans:"รายละเอียดราคา",
      titlemeeterror:"ผิดพลาด",
      contentmeeterror:"สิ้นสุดการประชุม",
      contentmeetiderror:"Meeting ID ไม่ถูกต้อง",
      titlefeature:"คุณสมบัติ",
      high_quality_video:"วิดีโอคุณภาพสูง",
      high_quality_video_details:"วิดีโอที่คมชัดพร้อมรองรับ 1080p HD รับประกันประสบการณ์ระดับมืออาชีพ",
      intuitive_interface:"อินเทอร์เฟซที่ใช้งานง่าย",
      intuitive_interface_details:"อินเทอร์เฟซที่ใช้งานง่ายของเราทำให้การโฮสต์ เข้าร่วม และจัดการวิดีโอเป็นเรื่องง่าย",
      seamless_collaboration:"การทำงานร่วมกันอย่างราบรื่น",
      seamless_collaboration_details:"แชร์หน้าจอของคุณพร้อมกัน เหมาะสำหรับการเปรียบเทียบเอกสารเคียงข้างกัน และรวบรวมข้อมูลหรือโหวตได้ทันทีด้วยโพลแบบโต้ตอบ",
      pricing:"ราคา",
      pricing_details:"เริ่มต้นใช้งานฟรีด้วยแผนพื้นฐานของเรา เหมาะสำหรับการใช้ส่วนบุคคลหรือทีมขนาดเล็ก หรืออัปเกรดเป็นแผนโปรที่คุ้มค่าและเหมาะสมสำหรับธุรกิจขนาดใหญ่ มีคุณสมบัติเพิ่มเติม เช่น การประชุมที่ยาวนานกว่า เพิ่มจำนวนผู้เข้าร่วม และการควบคุมการดูแลระดับสูง",
      get_in_touch:"ติดต่อเรา",
      get_in_touch_details1:"หากมีคำถามหรือข้อเสนอแนะ ทีมงานของเราพร้อมให้บริการคุณ แค่ส่งอีเมลไปที่",
      get_in_touch_details2:"หรือไปที่หน้า",
      contact_us:"ติดต่อเรา",
      get_in_touch_details3:"แล้วเราจะติดต่อกลับให้เร็วที่สุด",
      start_free:"ใช้งานฟรี",
      detail_page2:"ทำไมเราถึงแตกต่าง",
      detail_page2_1:"บันทึกรายงานการประชุมโดยทนายความที่ปรึกษา",
      detail_page2_1sub:"เอกลักษณ์เฉพาะของ Dmeets — รับบันทึกการประชุม อย่างเป็นทางการที่จัดทำโดยทนายความที่ปรึกษา ที่ถูกต้องและเป็นไปตามมาตรฐาน",
      detail_page2_2:"เป็นมิตรกับมืออาชีพและการศึกษา",
      detail_page2_2sub:"เหมาะสำหรับการประชุมทางธุรกิจ การหารือ ด้านกฎหมาย หรือ การศึกษา เรียนออนไลน์",
      detail_page2_3:"การจัดเก็บข้อมูลที่เป็นไปตามมาตรฐาน PDPA ในประเทศไทย",
      detail_page2_3sub:"ข้อมูลการประชุมของท่านได้รับการเก็บรักษาอย่างปลอดภัยภายในประเทศไทยเพื่อความเป็นส่วนตัวและสอดคล้องกับกฎหมายไทย",
      detail_page2_4:"ใครใช้ Dmeets?",
      detail_page2_4sub_1:"สำนักงานกฎหมายและฝ่ายกฎหมาย",
      detail_page2_4sub_2:"ทีมงานขององค์กร",
      detail_page2_4sub_3:"โรงเรียน มหาวิทยาลัย และผู้สอน",
      detail_page2_4sub_4:"องค์กรพัฒนาเอกชนและหน่วยงานราชการ ",
      detail_page2_4sub_5:"และอื่นๆ อีกมากมาย",
      detail_page3:"เริ่มต้นใช้งาน Dmeets ฟรี — ไม่ต้องใช้บัตรเครดิต และไม่ต้องติดตั้งเพิ่มเติม",
      detail_page3sub_1:"ประชุมได้อย่างมั่นใจ พร้อมฟีเจอร์แชร์หน้าจอและแชท",
      detail_page3sub_2:"จัดเก็บข้อมูลอย่างปลอดภัยในประเทศไทย รองรับ PDPA",
      detail_page3sub_3:"แพ็กเกจยืดหยุ่น ปรับได้ตามความต้องการของคุณ",
      detail_page3sub_4:"ไม่ว่าจะเป็นการประชุมธุรกิจหรือการเรียนออนไลน์ Dmeets มอบประสบการณ์ที่ง่าย และปลอดภัยในทุกครั้งที่ใช้งาน",

    },
    lg_mainpage_en: {
      title: "More than just Meetings",
      title_page2:"Why Choose Dmeets?",
      title_page3:"Start Free. No Commitment.",
      subtitle1: "Whether you're running a business, hosting a legal consultation, or teaching an online class — Dmeets makes it secure, accurate, and effortless.",
      subtitle2: "All in Dmeets and it's free to use.",
      privacy_consent:"Privacy Consent",
      text1:"DCM will treat any personal information you provide confidential and will only process such information in accordance to DCM Terms and Privacy Policy.",
      text2:"I have read and agree to DCM Terms and Privacy Policy.",
      accept:"Accept",
      notaccept:"Deny",
      ourpricingplans:"Our Pricing Plans",
      titlemeeterror:"Error",
      contentmeeterror:"The meeting was finished",
      contentmeetiderror:"Meeting ID Incorrect",
      titlefeature:"Features of Dmeets Online Meetings",
      high_quality_video:"High-Quality Video",
      high_quality_video_details:"Experience crystal-clear video with 1080p HD support, ensuring a professional and engaging online meeting.",
      intuitive_interface:"Intuitive Interface",
      intuitive_interface_details:"Easily host, join, and manage video calls with our user-friendly interface.",
      seamless_collaboration:"Seamless Collaboration",
      seamless_collaboration_details:"Share your screen, compare complex documents side by side, and gather instant insights with interactive polls for efficient collaboration.",
      pricing:"Pricing",
      pricing_details:"Start for free with our basic plan for personal use or small teams. Upgrade to our affordable Pro plan for expanded enterprise-grade features like longer meetings, more participants, and advanced admin controls.",
      get_in_touch:"Get in Touch",
      get_in_touch_details1:"Have a question or feedback? Our friendly customer support team is here to assist you. Just send an email to",
      get_in_touch_details2:"or visit our",
      contact_us:"Contact Us",
      get_in_touch_details3:"page and we'll get back to you as soon as possible.",
      start_free:"Start Free",
      detail_page2:"Why We’re Different",
      detail_page2_1:"Minutes by Legal Professionals",
      detail_page2_1sub:"Unique to Dmeets — Get official meeting minutes prepared by licensed solicitors—accurate, reliable, and compliant.",
      detail_page2_2:"Professional & Educational Friendly",
      detail_page2_2sub:"Ideal for business meetings, legal discussions, and learning sessions.",
      detail_page2_3:"PDPA-Compliant Data Hosting in Thailand",
      detail_page2_3sub:"Your meeting data is safely stored within Thailand for full privacy and legal compliance.",
      detail_page2_4:"Who Uses Dmeets?",
      detail_page2_4sub_1:"Law firms & legal departments",
      detail_page2_4sub_2:"Corporate teams",
      detail_page2_4sub_3:"Schools, universities & tutors",
      detail_page2_4sub_4:"government offices and many more",
      detail_page2_4sub_5:"and many more",
      detail_page3:"Get started with Dmeets for Free — no credit card, no setup required.",
      detail_page3sub_1:"Seamless meetings with screen sharing and chat",
      detail_page3sub_2:"Secure, PDPA-compliant data hosted in Thailand",
      detail_page3sub_3:"Flexible plans that grow with you",
      detail_page3sub_4:"From business meetings to online sessions, Dmeets delivers a simple, secure, and professional experience—every time.",
      

    },
  };
  